var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBellSolid = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.636 0a1.24 1.24 0 0 0-1.234 1.25V2c-2.815.578-4.935 3.102-4.935 6.125v.734c0 1.836-.667 3.61-1.87 4.985l-.285.324a1.268 1.268 0 0 0-.205 1.344c.197.449.64.738 1.126.738h14.805c.486 0 .925-.29 1.126-.738.2-.45.12-.977-.205-1.344l-.285-.324a7.568 7.568 0 0 1-1.87-4.985v-.734c0-3.023-2.12-5.547-4.935-6.125v-.75A1.24 1.24 0 0 0 8.636 0zm1.746 19.27a2.518 2.518 0 0 0 .721-1.77H6.168c0 .664.258 1.3.721 1.77a2.452 2.452 0 0 0 3.493 0z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBellSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell-solid.b61aa9f3.svg";
export { ForwardRef as ReactComponent };